import { motion } from "framer-motion";
import { ArrowUpRight, Waypoints } from "lucide-react";
import { Reveal } from "./Reveal";

const STONE = "https://images.unsplash.com/photo-1763683885548-acd5635b3610?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxhbmNpZW50JTIwc3RvbmUlMjBtb251bWVudCUyMG5pZ2h0fGVufDB8fHx8MTc4NDI1MjgzNnww&ixlib=rb-4.1.0&q=85";

export const Atlas = ({ settings }) => {
  const url = settings?.atlasUrl || "https://atlas-knowledge-gps.pplx.app/";
  return (
    <section id="atlas" className="relative py-16 md:py-24" data-testid="atlas-section">
      <div className="section-shell">
        <Reveal>
          <div className="relative overflow-hidden rounded-2xl border border-gold/20">
            <div className="absolute inset-0">
              <img src={STONE} alt="Ancient stone monument at night" className="h-full w-full object-cover" />
              <div className="absolute inset-0 bg-[#05060A]/85" />
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_50%,rgba(212,175,55,0.14),transparent_55%)]" />
            </div>

            <div className="relative flex flex-col gap-8 p-10 md:flex-row md:items-center md:justify-between md:p-16">
              <div className="max-w-xl">
                <div className="mb-5 inline-flex items-center gap-3 rounded-full border border-gold/40 px-4 py-1.5">
                  <Waypoints className="h-4 w-4 text-gold" strokeWidth={1.5} />
                  <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Companion</span>
                </div>
                <h2 className="font-display text-4xl md:text-5xl font-light leading-tight text-white">
                  Atlas — A GPS for Human Knowledge
                </h2>
                <p className="mt-5 font-sans text-base md:text-lg font-light leading-relaxed text-slate-300">
                  An interactive knowledge graph and adaptive learning routes that map prerequisites
                  and cross-domain connections across these topics of inquiry — a way to walk the
                  living garden as a single, navigable terrain.
                </p>
              </div>

              <motion.a
                href={url}
                target="_blank"
                rel="noreferrer"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.98 }}
                className="group inline-flex shrink-0 items-center gap-3 rounded-full border border-gold bg-gold/10 px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] text-gold transition-colors duration-300 hover:bg-gold hover:text-[#05060A]"
                data-testid="atlas-open-map"
              >
                Open the Knowledge Map
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.5} />
              </motion.a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
